import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { MaterialModule } from '../../material.module';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppStateService } from '../../app-state.service';
import { FormConfigService } from '../forms-config.service';
import { AppEventService } from '../../app-event-service';

@Component({
  selector: 'app-new-patient-form',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    DynamicFormComponent,  // Import the dynamic form component
  ],
  templateUrl: './new-patient-form.component.html',
  styleUrls: ['./new-patient-form.component.scss']
})
export class NewPatientFormComponent implements OnInit, OnDestroy {
  @Input() clientId: string = '';
  @Input() patientId: string = '';
  appStateService = inject(AppStateService);
  formConfigService = inject(FormConfigService);
  snackBar = inject(MatSnackBar);
  eventService = inject(AppEventService);

  constructor(private route: ActivatedRoute) {
    this.clientId = this.appStateService.getState().clientId || '';
    this.patientId = this.appStateService.getState().patientId || sessionStorage.getItem('patientId') || '';
  }

  ngOnInit(): void {
    this.eventService.dispatchEvent('disableChat', {});
    if (!this.patientId) {
      // Handle error: Redirect to login or show a message
    }
  }

  ngOnDestroy(): void {
    this.eventService.dispatchEvent('enableChat', {});
  }


}
